const DEFAULT_MIN_LENGTH = 12
const DEFAULT_MAX_LENGTH = 13

const normalizeValue = (value: unknown): string | undefined => {
  if (value === undefined || value === null || value === '') return undefined
  if (Array.isArray(value)) {
    const lastValue = value.at(-1)
    return typeof lastValue === 'string' ? lastValue.trim() : undefined
  }
  if (typeof value === 'string') return value.trim()
  if (typeof value === 'number') return String(value).trim()
  return undefined
}

const buildDeliveryNotePattern = (minLength: number, maxLength: number) =>
  new RegExp(String.raw`^\d{${minLength}${minLength !== maxLength ? `,${maxLength}` : ''}}$`)

const isValidDeliveryNote = (
  value: unknown,
  minLength = DEFAULT_MIN_LENGTH,
  maxLength = DEFAULT_MAX_LENGTH,
) => {
  const normalized = normalizeValue(value)
  if (!normalized || !/^\d+$/.test(normalized)) return false
  return normalized.length >= minLength && normalized.length <= maxLength
}

export const DeliveryNoteUtils = {
  DEFAULT_MIN_LENGTH,
  DEFAULT_MAX_LENGTH,
  normalizeValue,
  buildDeliveryNotePattern,
  isValidDeliveryNote,
}
